export default __webpack_public_path__ + "static/media/pdf.caf2d716.svg";